import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
// import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

const state = {
  rows: [],
  row: {},
  condition: {}
}
const actions = {
  doSubmit: ({ commit, state }, row) => {
    const ctx = {
      data: {
        doSubmit: { api: 'M0501MailerService.doContact', input: row }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        return data.doSubmit.output
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
